import { InjectionToken } from '@angular/core';

/**
 * NestJS API origin without a trailing slash (e.g. `http://localhost:3000`).
 * Provided by the web app from `environment.apiUrl`; defaults to local for tests.
 */
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL', {
  providedIn: 'root',
  factory: () => 'http://localhost:3000',
});
